import Grid, { GridProps } from '@material-ui/core/Grid'
import React from 'react'

/** Wrapper component for &lt;Grid item /> */
const GridItem = React.forwardRef<unknown, GridProps>((props, ref) => (
    <Grid item innerRef={ref} {...props} />
))

GridItem.displayName = 'GridItem'

export default GridItem
